import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/Login";
import Homepage from "./pages/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import LicensePage from "./pages/License";
import DetailsLicensePage from "./pages/DetailsLicense";
import ChangePwPage from "./pages/ChangePw";
import ManageLogo from "./pages/ManageLogo";
import { getAllLogo } from "./services/userServices";

const App = () => {
  const updateFavicon = (imageUrl) => {
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
      favicon.href = imageUrl;
    }

    const appleIcon = document.querySelector("link[rel~='apple-touch-icon']");
    if (appleIcon) {
      appleIcon.href = imageUrl;
    }
  };

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const result = await getAllLogo();
        // console.log(result, "result");
        const imagePath = result.respObj.image;
        if (imagePath) {
          const fullUrl = `https://dcu.dev.api.jeyunvn.com${imagePath}`;
          updateFavicon(fullUrl);
        }
      } catch (error) {
        console.error("Failed to fetch logo:", error);
      }
    };

    fetchLogo();
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<Homepage />} />
          <Route path="/manage-license" element={<LicensePage />} />
          <Route
            path="/details-license/:key"
            element={<DetailsLicensePage />}
          />
          <Route path="/manage-logo" element={<ManageLogo />} />
          <Route path="/change-password" element={<ChangePwPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
